import { ETimePreference, EVerticalNames } from '@constants';
import { IUser } from '@sdk/contracts';
import { Form, FormInstance, Input } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Wrapper, TitleWrapper } from './WkcFormContent.styles';

import { AutonomousCommunitySelector } from '@/components/Form';
import { GridOptionsSelector } from '@/components/GridOptionsSelector';

type Props = {
  form: FormInstance<IUser>;
};

export const WkcFormContent: React.FC<Props> = ({ form }) => {
  const { t } = useTranslation(['DefaultTranslations', 'StudentProfileConfigurationTranslations']);
  const [showCurrentOccupationField, setShowCurrentOccupationField] = useState(false);
  //TODO: ¿Qué hacemos con los workcamps?? Los añadimos al userInfo??
  return (
    <Wrapper>
      <TitleWrapper>{t(EVerticalNames.WKC)}</TitleWrapper>
      <Form.Item
        name={['trainingInfo', EVerticalNames.WKC, 'occupation']}
        label={t('StudentProfileConfigurationTranslations:WHAT_IS_YOUR_OCCUPATION')}>
        <Input />
      </Form.Item>
      <Form.Item
        name={['trainingInfo', EVerticalNames.WKC, 'showCurrentOccupationField']}
        label={t('StudentProfileConfigurationTranslations:ARE_YOU_CURRENTLY_WORKING')}
        initialValue={showCurrentOccupationField}>
        <GridOptionsSelector
          value={showCurrentOccupationField}
          options={[true, false]}
          onChange={value => setShowCurrentOccupationField(value)}
        />
      </Form.Item>
      {showCurrentOccupationField && (
        <Form.Item
          name={['trainingInfo', EVerticalNames.WKC, 'currentOccupation']}
          label={t('StudentProfileConfigurationTranslations:WHAT_IS_YOUR_CURRENT_OCCUPATION')}>
          <Input />
        </Form.Item>
      )}
      <Form.Item
        name={['trainingInfo', EVerticalNames.WKC, 'autonomousCommunity']}
        label={t('StudentProfileConfigurationTranslations:IN_WHICH_CA_DO_YOU_LIVE')}
        style={{ marginBottom: '10px' }}>
        <AutonomousCommunitySelector allowClear />
      </Form.Item>
      <Form.Item
        name={['trainingInfo', EVerticalNames.WKC, 'liveClassesTimePreference']}
        label={t('StudentProfileConfigurationTranslations:WHEN_DO_YOU_PREFER_LIVE_CLASSES')}
        initialValue={showCurrentOccupationField}>
        <GridOptionsSelector
          value={form.getFieldValue([
            'trainingInfo',
            EVerticalNames.WKC,
            'liveClassesTimePreference'
          ])}
          options={Object.values(ETimePreference)}
          onChange={value =>
            form.setFields([
              {
                name: ['trainingInfo', EVerticalNames.WKC, 'liveClassesTimePreference'],
                value
              }
            ])
          }
        />
      </Form.Item>
    </Wrapper>
  );
};
